module.exports = __webpack_public_path__ + "img/botaosttrfetrominasarcossetcom.f39bc37f.png";